module.exports = __webpack_public_path__ + "img/p2_bg.459a3ec8.jpg";